import PropTypes from 'prop-types'

export const BellNotificationPropType = PropTypes.shape({
  title: PropTypes.string,
  message: PropTypes.any,
  rawHtml: PropTypes.string,
  color: PropTypes.string,
  iconName: PropTypes.string,
  messageId: PropTypes.number,
  timestamp: PropTypes.string,
})
